import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthenticationService} from '../../../authentication/services/authentication.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);
  if (authenticationService.isAuthenticated) {
    return true;
  }
  return router.createUrlTree(['/login'], {queryParams: {redirect: state.url}});
}
